import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Button } from "@platform/design-system";

import type React from "react";

interface PasteRatesConfirmDialogProps {
  open: boolean;
  destinationPlanLabel: string;
  sourcePlanLabel: string;
  isPasting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function PasteRatesConfirmDialog({
  open,
  destinationPlanLabel,
  sourcePlanLabel,
  isPasting,
  onConfirm,
  onCancel,
}: PasteRatesConfirmDialogProps): React.JSX.Element {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Paste Rates</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will replace the existing rate structure on{" "}
          <strong>{destinationPlanLabel}</strong> with rates copied from{" "}
          <strong>{sourcePlanLabel}</strong>. This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isPasting} variant="secondary">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="primary" disabled={isPasting}>
          {isPasting ? "Pasting…" : "Paste"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
